import * as types from '../constants';

const initialState = {
  language: 'ko',
};

const ConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PAGE_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
};

export default ConfigReducer;